import { createPortal } from "react-dom";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import "../../../../css/DebtConsolidationCalculator/averageRatesModal.css";

export default function AverageRatesModal({ open, onClose, rates }) {
  if (!open) return null;

  // Determine dynamic band headers
  const bandSet = new Set();
  Object.values(rates || {}).forEach((obj) => {
    Object.keys(obj || {}).forEach((k) => bandSet.add(k));
  });
  const bands = Array.from(bandSet);

  const fmtVal = (v) => (v ? String(v) : "-");

  return createPortal(
    <div
      className="dcc-modal"
      role="dialog"
      aria-modal="true"
      aria-label="Average APR reference table"
      onClick={(e) => {
        if (e.target.classList.contains("dcc-modal")) onClose?.();
      }}
    >
      <div className="dcc-modal-content">
        <div className="dcc-modal-header">
          <div className="Content-Bold-Underline">
            Average Interest Rates
          </div>
          <button
            type="button"
            onClick={onClose}
            className="dcc-close-btn"
            aria-label="Close"
          >
            <CloseIcon className="dcc-close-icon" />
          </button>
        </div>

        <div className="dcc-modal-body">
          <table className="dcc-apr-table">
            <thead>
              <tr>
                <th>
                  <div className="Content-SemiBold">Product Type</div>
                </th>
                <th>
                  <div className="Content-SemiBold">Good Credit</div>
                </th>
                <th>
                  <div className="Content-SemiBold">
                    Credit Impaired / Higher-Risk
                  </div>
                </th>
                {/* {bands.map((b) => (
                  <th key={b}>
                    <div className="Content-SemiBold">
                      {b
                        .replace(/([A-Z])/g, " $1")
                        .replace(/^./, (c) => c.toUpperCase())
                        .trim()}
                    </div>
                  </th>
                ))} */}
              </tr>
            </thead>
            <tbody>
              {Object.entries(rates || {}).map(([type, obj]) => (
                <tr key={type}>
                  <td>
                    <div className="Content-Small">{type}</div>
                  </td>
                  {bands.map((b) => (
                    <td key={b}>
                      <div className="Content-Small">{fmtVal(obj?.[b])}</div>
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>,
    document.body
  );
}
